import React, { useEffect, useRef, useState, useLayoutEffect } from '@wordpress/element'
import DefaultSlide from './slide-styles/Default.jsx'
import TopSlide from './slide-styles/Top.jsx'
import CareerSlide from './slide-styles/Career.jsx'
import { blockAttributes, extractBlockStyle } from '../utils'
import { useKeenSlider } from 'keen-slider/react'
import blockDefinition from './block.json';

export const Component = ({ attributes, showSlide, sliderRef = null, renderAll, onShowSlide = () => {} }) => {
  const { slides, className, min_height} = blockAttributes(attributes, blockDefinition);
  // const { title, text, bgUrl, link, className} = attributes;
  const style = extractBlockStyle(className)
  const font_sizes = {
    large: { header: 'text-4xl md:text-7xl leading-12 md:leading-18', text: 'md:text-3xl md:leading-10' },
    medium: { header: 'text-3xl md:text-5xl leading-10 md:leading-14', text: 'md:text-2xl md:leading-8' },
    small: { header: 'text-2xl leading-8 md:text-3xl md:leading-10 font-bold', text: 'md:text-2xl md:leading-8' }
  }

  const heights = {
    full_screen: 'lg:min-h-screen-no-menu',
    tall: 'lg:min-h-175',
    short: 'lg:min-h-125',
  };

  const Slide = ({ data }) => {
    const { title, text, bgDesktopUrl, bgMobileUrl, reverse, font_size, tag, link } = data;
    const attrs = {
      title,
      text,
      tag,
      font_size: font_sizes[font_size] || font_sizes['medium'],
      min_height: heights[min_height],
      bgDesktop: bgDesktopUrl,
      bgMobile: bgMobileUrl,
      link,
      reverse,
      className: ''
    }

    switch (style) {
      case 'top':
        return <TopSlide {...attrs} light={false}/>
      case 'light':
        return <TopSlide {...attrs} light={true}/>
      case 'career':
        return <CareerSlide {...attrs} />
      default:
        return <DefaultSlide {...attrs} />
    }
  }

  return <div className={'relative'}>
    <div ref={sliderRef} className={'keen-slider relative rtl:flex-row-reverse'}>
      {slides.map((slide, key) => {
        return (renderAll || key === showSlide) &&
          <div key={key} className={'keen-slider__slide min-w-full'}><Slide data={slide} /></div>
      })}
    </div>
    {slides.length > 1 && <nav
      className="dots md:absolute md:bottom-8 md:left-0 md:w-full py-6 md:py-0 flex justify-center md:z-20 flex space-x-reverse space-x-4">
      {slides.map((slide, key) => {
        return (
          <button
            key={key}
            onClick={() => onShowSlide(key)}
            className={'dot border-none cursor-pointer w-3 h-3 rounded-full ' + (showSlide === key ? ' bg-blue-300 active' : 'bg-blue-900')}
          />
        )
      })}
    </nav>}
  </div>
}

const Slider = ({ ...attrs }) => {
  return <div>
    <Component {...attrs} showSlide={0} renderAll={true}/>
  </div>
}

export const FrontComponent = ({ attributes }) => {
  const attrs = blockAttributes(attributes, blockDefinition)
  const [currentSlide, setCurrentSlide] = useState(0)
  const [pause, setPause] = useState(false)
  const timer = useRef()
  const { slides } = attrs;
  const hasSlider = slides.length > 1;

  const SLIDE_SECONDS = 7;

  // Don't init
  const [sliderRef, slider] = !hasSlider ? [useRef(), null] : useKeenSlider({
    initial: currentSlide,
    duration: 500,
    loop: true,
    // dragStart: () => {
    //   setPause(true)
    // },
    slideChanged: (d) => {
      const details = d.details()
      if (details.relativeSlide !== (currentSlide % details.size)) {
        setCurrentSlide(details.relativeSlide)
      }
    },
    // dragEnd: () => {
    //   setPause(false)
    // },
  })

  useEffect(() => {
    if (!hasSlider ) {
      return;
    }
    timer.current = setInterval(() => {
      if (!pause && slider) {
        slider.next()
      }
    }, SLIDE_SECONDS * 1000)
    return () => {
      clearInterval(timer.current)
    }
  }, [pause, slider])

  useLayoutEffect(() => {
    if (slider && slider.details().realtiveSlide !== currentSlide) {
      slider.moveToSlideRelative(currentSlide % slider.details().size);
    }
  }, [currentSlide])


  // Fix issue with link not being triggered inside slider
  useLayoutEffect(() => {
    if(sliderRef && sliderRef.current) {

      const stopProp = e => {
        if(e.target.matches('a[href] *') || e.target.matches('a[href]')) {
          e.stopPropagation();
        }
      };

      sliderRef.current.addEventListener('mousedown', stopProp, true);

      return () => {
          sliderRef.current.removeEventListener('mousedown', stopProp)
      }
    }
  }, [sliderRef])

  return <Component sliderRef={sliderRef || null} slider={slider || null} attributes={attrs} onShowSlide={setCurrentSlide}
    showSlide={currentSlide} renderAll={true}/>
}

export default Slider
